export const ADD_PARTICIPANT_DRAWER = 'ADD_PARTICIPANT_DRAWER';
export const ADD_PARTICIPANT_SELECT = 'ADD_PARTICIPANT_SELECT';
export const ADD_PARTICIPANT_FORM = 'participantSearch';
export const ADD_PARTICIPANT_FORM_FOCUSED = 'ADD_PARTICIPANT_FORM_FOCUSED';
export const CLEAR_PARTICIPANT_ADD_LIST = 'CLEAR_PARTICIPANT_ADD_LIST';
